export function getNumberOfColumns(stepType) {
  const numberOfColumns = stepType === 'automaticDoor' || stepType === 'montage' || stepType === 'subGoal' ? 2
    : stepType === 'houseType' || stepType === 'houseStyle' || stepType === 'areaOfUse' ? 3
    : stepType === 'garageType' ? 4
    : 2;
  return numberOfColumns;
}

export function toKebabCase(str) {
  return str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map(x => x.toLowerCase())
    .join('-');
}
